function formatOption(option) {
  if (!option.id) return option.text;

  const $el = $(option.element);
  const description = $el.data('description') || '';
  const extra = $el.data('extra') || '';

  return $(`
      <div style="display: flex; flex-direction: row; padding: 8px; justify-content: space-between; width: 100%">
        <div style="display: flex; flex-direction: column;">
          <strong>${option.text}</strong>
          <small style="color: gray;">${description}</small>
        </div>
        <strong>${extra}</strong>
      </div>
    `);
}

function initSelectsOnce(selector, config) {
  $(selector).each(function () {
    if (!$(this).hasClass('select2-hidden-accessible')) {
      $(this)
        .select2(config)
        .on('select2:select', function () {
          this.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initSelectsOnce('.select2:not(.select2Service)', {
    minimumResultsForSearch: -1,
  });
  initSelectsOnce('.select2Service', {
    templateResult: formatOption,
    templateSelection: function (option) {
      if (!option.id) return option.text;
      return $(`<span style="text-align: left; display: block;">${option.text}</span>`);
    },
    minimumResultsForSearch: -1,
  });
});
